'use client';

import { c as _c } from "react/compiler-runtime";
import { type RefObject, useCallback, useEffect, useRef } from 'react';

// @see https://github.com/akiran/react-slick/issues/1240#issuecomment-513235261
export const usePreventVerticalScroll = (ref, t0) => {
  const $ = _c(7);
  const dragThreshold = t0 === undefined ? 25 : t0;
  const firstClientX = useRef(0);
  const clientX = useRef(0);
  let t1;
  if ($[0] !== dragThreshold) {
    t1 = event => {
      clientX.current = event.touches[0].clientX - firstClientX.current;
      if (Math.abs(clientX.current) > dragThreshold) {
        event.preventDefault();
        event.returnValue = false;
        return false;
      }
      return true;
    };
    $[0] = dragThreshold;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const preventTouch = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = event_0 => {
      firstClientX.current = event_0.touches[0].clientX;
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const touchStart = t2;
  let t3;
  let t4;
  if ($[3] !== preventTouch || $[4] !== ref) {
    t3 = () => {
      const current = ref?.current;
      if (current) {
        current.addEventListener("touchstart", touchStart);
        current.addEventListener("touchmove", preventTouch, {
          passive: false
        });
      }
      return () => {
        if (current) {
          current.removeEventListener("touchstart", touchStart);
          current.removeEventListener("touchmove", preventTouch);
        }
      };
    };
    t4 = [preventTouch, ref, touchStart];
    $[3] = preventTouch;
    $[4] = ref;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
};